import React from "react";
import { useTranslation } from "react-i18next";
import { UserProfile } from "../../../../types/userAuthApiTypes";
import { UserTab } from "../../../../userSlice";
import Icon from "../../../../../../common/components/Icon/Icon";

interface DashboardHomeProps {
  profile: UserProfile | undefined;
  isLoading: boolean;
  onTabChange: (tab: UserTab) => void;
}

const DashboardHome: React.FC<DashboardHomeProps> = ({
  profile,
  isLoading,
  onTabChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="dashboard-welcome">
      <h3 className="dashboard-welcome__title">
        {t("user.dashboard.welcome.greeting", {
          name: isLoading ? "..." : profile?.displayName,
          defaultValue: "Hello, {{name}}",
        })}
      </h3>

      <p className="dashboard-welcome__intro">
        {t(
          "user.dashboard.welcome.introStart",
          "From your account dashboard you can:"
        )}
      </p>

      <div className="dashboard-welcome__actions">
        {/* Orders Action */}
        <button
          className="dashboard-welcome__action-card"
          onClick={() => onTabChange("orders")}
        >
          <div className="dashboard-welcome__icon-wrapper">
            <Icon iconName="shopping-bag" className="icon--stroke-thick" />
          </div>
          <span className="dashboard-welcome__action-text">
            {t("user.dashboard.welcome.viewOrders", "View your recent orders")}
          </span>
          <Icon iconName="arrow-right" className="dashboard-welcome__arrow" />
        </button>

        {/* Addresses Action */}
        <button
          className="dashboard-welcome__action-card"
          onClick={() => onTabChange("addresses")}
        >
          <div className="dashboard-welcome__icon-wrapper">
            <Icon iconName="map-pin-filled" className="icon--filled" />
          </div>
          <span className="dashboard-welcome__action-text">
            {t(
              "user.dashboard.welcome.manageAddresses",
              "Manage your shipping and billing addresses"
            )}
          </span>
          <Icon iconName="arrow-right" className="dashboard-welcome__arrow" />
        </button>

        {/* Account Details Action */}
        <button
          className="dashboard-welcome__action-card"
          onClick={() => onTabChange("account")}
        >
          <div className="dashboard-welcome__icon-wrapper">
            <Icon iconName="user" className="icon--stroke-thick" />
          </div>
          <span className="dashboard-welcome__action-text">
            {t(
              "user.dashboard.welcome.introLinkText",
              "Edit your password and account details"
            )}
          </span>
          <Icon iconName="arrow-right" className="dashboard-welcome__arrow" />
        </button>
      </div>
    </div>
  );
};

export default DashboardHome;
